import * as types from './mutation-types';
import createError from "@/clir/utils/createError";
import getKey from '@/clir/utils/getKey';

export default {
    reset: ({ commit }) => {
        commit(types.SET_ERROR_STATUS, null);
        commit(types.SET_ERROR_STATUS_TEXT, null);
        commit(types.SET_ERROR_OPTIONS, {});
    },
    pushError: ({ commit }, error) => {
        const status = getKey(error, 'code', undefined) ||  getKey(error, 'status', 'xxx');
        const statusText = getKey(error, 'errorDescription', undefined) || getKey(error, 'statusText', 'Erreur inconnue');
        const err = createError({
            status,
            statusText }, 
            {
                errorList: getKey(error,'options.errorList', []),
            });
        commit(types.SET_ERROR, err);
        return err;
    },
    unAuthorised: ({ commit }, route) => {
        const err = createError({
            status: "401",
            statusText: "Vous n'êtes pas habilité à consulter cette page."
        }, {
            route: route || { name: 'Login' },
        });
        commit(types.SET_ERROR, err);
        return err;
    },
    notAuthenticated: ({ commit }, route) => {
        const err = createError({
            status: "401",
            statusText: "Vous devez vous authentifier avant de pouvoir continuer.",
        }, {
            route: route || { name: 'Login' },
        });
        commit(types.SET_ERROR, err);
        return err;
    },
};